export const dataHooks = {
  testimonial: 'testimonial',
  testimonialAvatar: 'testimonialAvatar',
  testimonialText: 'testimonialText',
  testimonialAuthorName: 'testimonialAuthorName',
};

export const MOBILE_COLS = 1;
